import { t } from '@/i18n';
import { delay } from '@/utils/delay';
import { useAppStore } from '@/store/app';
import { useSystemStore } from '@/store/system';
import { useChannelStore } from '@/store/channel';
import { Autoplay, Pagination } from 'swiper/modules';
import { checkBrowser, checkWebView } from '@/utils/pwa/browser';
import router from '@/router';

let checkTimer: NodeJS.Timeout; // 检测定时器

const route = router.currentRoute;  // 当前路由

const progress = ref(0);                      // 安装进度
const checked = ref(false);                   // 是否检测完成
const loading = ref(false);                   // 是否加载中
const checking = ref(false);                  // 是否检测中
const showGoogleInfo = ref(false);            // 是否显示Google信息
const modules = ref([Autoplay, Pagination]);  // 轮播图模块

const fromUrl = computed(() => route.value.query.from as string || ''); // 生命周期: 页面加载前

export function useDownloadLogic() {
  const appStore = useAppStore();         // 用户信息
  const systemStore = useSystemStore();   // 系统信息
  const channelStore = useChannelStore(); // 渠道信息

  const unStandalone = computed(() => appStore.unStandalone);             // 是否未在PWA中运行且可以安装PWA
  const template = computed(() => channelStore.downloadTemplate);         // APK下载模板信息

  /**
   * @description 检测按钮点击事件
   */
  function checkHandle() {
    const webView = checkWebView();
    if (webView)
      return checkBrowser();

    checking.value = true;  // 设置检测状态

    checkTimer = setInterval(() => {
      if (progress.value < 100) {
        const installButton = document.querySelector('.progressier-install-button');  // 使用querySelector获取按钮元素
        const buttonText = installButton?.textContent;                                // 获取按钮的当前文本内容
        if (unStandalone.value || buttonText == t('label.launchApp')) {               // 判断是否可以安装PWA或按钮文本内容是否为'打开应用'
          progress.value += 5;
        } else {
          progress.value += 1;
        }
      } else {
        checkPawInstallButton();
        progress.value = 100;
        checked.value = true;
        clearInterval(checkTimer);
      }
    }, 50);
  }

  /**
   * @description swiper初始化完成
   * @param swiper
   */
  async function onSwiper(swiper: any) {
    await delay(3000);
    swiper.slideTo(1); // 滑动到第一个slide
  };

  return {
    checking,
    systemStore,
    channelStore,
    fromUrl,
    template,
    showGoogleInfo,
    loading,
    checkTimer,
    modules,
    checkHandle,
    onSwiper,
  }
}

/**
 * @description 检查Paw安装按钮
 */
function checkPawInstallButton() {
  const appStore = useAppStore();                                               // 获取appStore

  const installButton = document.querySelector('.progressier-install-button');  // 使用querySelector获取按钮元素
  const buttonText = installButton?.textContent;                                // 获取按钮的当前文本内容
  if (buttonText == t('label.launchApp'))                                       // 判断按钮文本内容是否为'打开应用'
    appStore.setPwaLaunchAllow(true);                                           // 设置PWA启动允许
}